var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMobileMode)?_c('mobilePart'):_c('pcPart')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }